const initState = {
  searchedManager: [],
  managerSeasonalTotalRating: {
    satisfied: 0,
    unSatisfied: 0,
    rating: 0,
    totalReviews: 0
  },
  managerSeasonalRating: [],
  managerTalkingTotalRating: {
    satisfied: 0,
    unSatisfied: 0,
    rating: 0,
    totalReviews: 0
  },
  managerTalkingRating: [],
  managerChatTotalRating: { S: 0, NS: 0, RST: 0 },
  managerChatRating: [],
  managerMomentoTotalRating: {
    satisfied: 0,
    unSatisfied: 0,
    rating: 0,
    totalReviews: 0
  },
  managerMomentoRating: [],
  managerTotalRatings: {},
  strategyRating: [],
  //  Requests
  requests: [],
  lastDocument: null,
  hasMore: true
};
const managerReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADD_REQUEST":
      return {
        ...state,
        requests: [action.payload, ...state.requests]
      };
    case "FETCH_REQUEST_MANAGER":
      return {
        ...state,
        requests: action.payload.data,
        lastDocument: action.payload.lastVisible,
        hasMore: action.payload.hasMore
      };
    case "FETCH_REQUEST_MANAGER_LOAD_MORE":
      return {
        ...state,
        requests: [...state.requests, ...action.payload.data],
        lastDocument: action.payload.lastVisible,
        hasMore: action.payload.hasMore
      };
    case "DELETE_REQUEST":
      return {
        ...state,
        requests: state.requests.filter(
          (request) => request.id !== action.payload
        )
      };
    case "EDIT_REQUEST":
      return {
        ...state,
        requests: state.requests.map((request) =>
          request.id === action.payload.id
            ? { ...request, ...action.payload }
            : request
        )
      };
    case "GET_STRATEGY_RATING":
      return {
        ...state,
        strategyRating: action.payload
      };
    case "GET_MANAGER_STATS":
      return {
        ...state,
        managerTotalRatings: action.payload
      };
    case "SEARCH_MANAGER":
      return {
        ...state,
        searchedManager: action.payload
      };
    case "CLEAR_SEARCH_MANAGER":
      return {
        ...state,
        searchedManager: []
      };
    case "MANAGER_SEASONAL_RATING":
      return {
        ...state,
        managerSeasonalTotalRating: action.payload.totalRating,
        managerSeasonalRating: action.payload.data
      };
    case "MANAGER_TALKING_RATING":
      return {
        ...state,
        managerTalkingTotalRating: action.payload.totalRating,
        managerTalkingRating: action.payload.data
      };
    case "MANAGER_CHAT_RATING":
      return {
        ...state,
        managerChatTotalRating: action.payload.totalRating,
        managerChatRating: action.payload.data
      };
    case "MANAGER_MOMENTO_RATING":
      return {
        ...state,
        managerMomentoTotalRating: action.payload.totalRating,
        managerMomentoRating: action.payload.data
      };
    default:
      return {
        ...state
      };
  }
};
export default managerReducer;
